<div
  class="calendar"
  [class.drop-shadow]="!disableDropShadow"
  *ngIf="navigatorStateService.activeDate$ | async as activeDate"
  [attr.data-year]="activeDate.year"
  [attr.data-month]="activeDate.month"
  #wrapper
>
  <app-month-navigator *ngIf="calendarView === 'Month'"></app-month-navigator>

  <table *ngIf="dayContainerWidth$ | async as dayContainerWidth">
    <caption *ngIf="calendarView === 'Year'">
      <app-body bold>{{ activeMonth }}</app-body>
    </caption>
    <tr>
      <th *ngFor="let weekday of weekdays">{{ weekday.substring(0, 1) }}</th>
    </tr>
    <tr *ngFor="let week of calendarMonthWeek$ | async">
      <ng-container *ngFor="let day of week">
        <td [attr.data-day-of-month]="day?.dayOfMonth" [ngClass]="getDayCss(day)" (click)="clickDay(day)" tid="calendar-day-container">
          <div
            class="day-container"
            [style.width.px]="dayContainerWidth"
            [style.height.px]="dayContainerWidth"
            [style.line-height.px]="dayContainerWidth"
          >
            <app-calendar-day-icon *ngIf="day?.hasEvent" [day]="day"></app-calendar-day-icon>
            <div class="date">{{ day?.dayOfMonth ?? '&nbsp;' }}</div>
          </div>
        </td>
      </ng-container>
    </tr>
  </table>
</div>
